export default __webpack_public_path__ + "static/media/Roboto-BlackItalic.84d93eb0.ttf";